const autoNgTemplateLoaderTemplate1 = require('./kube-deploy-description.html');

export const kubeDeployDescription = {
  templateUrl: autoNgTemplateLoaderTemplate1,
};
